export const API_BASE_URL = 'https://webapi.algoanalytics.com/api';